var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import React, { forwardRef } from 'react';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import NxFontAwesomeIcon from '../NxFontAwesomeIcon/NxFontAwesomeIcon';
import { NxErrorAlert } from '../NxAlert/NxAlert';
import { propTypes } from './types';
export { propTypes } from './types';
/**
 * A component that conditionally renders standardized DOM for error messages, optionally with a retry button.
 * If there is no error, this component renders nothing.
 * @param error if defined/non-null, is a string error message
 * @param titleMessage An optional string to display before the actual error output.  If not defined, defaults
 * to "An error occurred loading data."
 * @param retryHandler If this is defined, a Retry button will be rendered which executes this function when clicked
 */
var NxLoadError = forwardRef(function NxLoadError(_a, ref) {
    var error = _a.error, titleMessage = _a.titleMessage, retryHandler = _a.retryHandler, otherProps = __rest(_a, ["error", "titleMessage", "retryHandler"]);
    return error != null && (React.createElement(NxErrorAlert, __assign({}, otherProps, { ref: ref }),
        React.createElement("span", null, titleMessage || 'An error occurred loading data.'),
        ' ',
        React.createElement("span", null, error),
        retryHandler &&
            React.createElement("div", { className: "nx-btn-bar" },
                React.createElement("button", { className: "nx-btn nx-btn--error", onClick: retryHandler },
                    React.createElement(NxFontAwesomeIcon, { icon: faSync }),
                    React.createElement("span", null, "Retry"))))) || null;
});
NxLoadError.propTypes = propTypes;
export default NxLoadError;
//# sourceMappingURL=NxLoadError.js.map